export default class SearchEngine {
    constructor(config) {
        // Check iniziale info base
        if (!config.formId || !config.apiUrl || !config.initialData) {
            throw new Error("SearchEngine: Missing required configuration");
        }
        this.formId = config.formId;
        this.apiUrl = config.apiUrl;
        this.initial = {
            prices: {
                // `?? 0`: se lo stock non ha un prezzo minimo il valore di
                // partenza (e il fallback degli input) deve essere 0, non null
                min: config.initialData.initialPricesKm.min_price ?? 0,
                max: config.initialData.initialPricesKm.max_price + 30000,
                maxStock: config.initialData.initialPricesKm.max_price,
            },
            km: {
                min: config.initialData.initialPricesKm.min_km ?? 0,
                max: config.initialData.initialPricesKm.max_km + 30000,
                maxStock: config.initialData.initialPricesKm.max_km,
            },
            type: config.initialData.type, // Array
            warranties: config.initialData.warranties, // Array
            group: config.initialData.group, // Array
            body_type: config.initialData.body_type,
            brand: config.initialData.brand,
            serie: config.initialData.serie,
            model: config.initialData.model,
            fuel_type: config.initialData.fuel_type,
            gear_type: config.initialData.gear_type,
            min_price: config.initialData.min_price,
            max_price: config.initialData.max_price,
            min_km: config.initialData.min_km,
            max_km: config.initialData.max_km,
        };
        this.inputs = {
            hidden: {
                prices: {
                    min: document.getElementById(`${this.formId}price_min_val`),
                    max: document.getElementById(`${this.formId}price_max_val`),
                },
                km: {
                    min: document.getElementById(`${this.formId}km_min_val`),
                    max: document.getElementById(`${this.formId}km_max_val`),
                },
            },
        };
        this.checkboxes = {
            types: document.querySelectorAll(
                `#${this.formId} input[name="type[]"]`,
            ),
            warranties: document.querySelectorAll(
                `#${this.formId} input[name="warranties[]"]`,
            ),
            groups: document.querySelectorAll(
                `#${this.formId} input[name="gruppi[]"]`,
            ),
        };
        this.sliders = {
            budget: document.getElementById(`${this.formId}slider-budget`),
            km: document.getElementById(`${this.formId}slider-km`),
            inputsPrices: {
                min: document.getElementById(`${this.formId}input-price-first`),
                max: document.getElementById(`${this.formId}input-price-last`),
            },
            inputsKm: {
                min: document.getElementById(`${this.formId}input-km-first`),
                max: document.getElementById(`${this.formId}input-km-last`),
            },
        };
        this.selects = ["bodytype", "brand", "serie", "model", "fuel", "gear"];
        this.loaders = {
            wrapper: document.getElementById(`${this.formId}wrapper_sliders`),
            loader: document.querySelector(
                `#${this.formId} .container_sliders .loader`,
            ),
            show: true,
        };
        this.resetButtons = document.querySelectorAll(
            `#${this.formId} .reset.reset_filtri`,
        );
        this.conteggio = {
            element: document.getElementById(`${this.formId}conteggio`),
        };
        this.update_prices = true;
        this.update_input_prices = true;
        this.useInitialValues = true;
        this.useInitialPricesKm = true;
        this.initSliders();
        this.bindEvents();
        this.firstCheck();
    }

    // Init Sliders
    initSliders() {
        // Budget Slider
        if (this.sliders.budget) {
            noUiSlider.create(this.sliders.budget, {
                start: [this.initial.prices.min, this.initial.prices.max],
                connect: true,
                range: {
                    min: this.initial.prices.min,
                    max: this.initial.prices.max,
                },
            });
            this.sliders.budget
                .querySelector(".noUi-handle-lower")
                .setAttribute("aria-label", "Prezzo minimo");
            this.sliders.budget
                .querySelector(".noUi-handle-upper")
                .setAttribute("aria-label", "Prezzo massimo");
        }
        // KM Slider
        if (this.sliders.km) {
            noUiSlider.create(this.sliders.km, {
                start: [this.initial.km.min, this.initial.km.max],
                connect: true,
                range: {
                    min: this.initial.km.min,
                    max: this.initial.km.max,
                },
            });
            this.sliders.km
                .querySelector(".noUi-handle-lower")
                .setAttribute("aria-label", "Km minimi");
            this.sliders.km
                .querySelector(".noUi-handle-upper")
                .setAttribute("aria-label", "Km massimi");
        }
    }

    // Binding eventi classe
    bindEvents() {
        this.bindSliderEvents();
        this.bindCheckboxEvents();
        this.bindSelectEvents();
        this.bindResetEvent();
    }

    // Gestione eventi sliders
    bindSliderEvents() {
        if (this.sliders.budget && this.sliders.budget.noUiSlider) {
            this.sliders.inputsPrices.min?.addEventListener("change", (e) => {
                this.sliders.budget.noUiSlider.set([e.target.value, null]);
                this.onSliderChange("budget");
            });

            this.sliders.inputsPrices.max?.addEventListener("change", (e) => {
                this.sliders.budget.noUiSlider.set([null, e.target.value]);
                this.onSliderChange("budget");
            });

            this.sliders.budget.noUiSlider.on("change", () =>
                this.onSliderChange("budget"),
            );
        }

        if (this.sliders.km && this.sliders.km.noUiSlider) {
            this.sliders.inputsKm.min?.addEventListener("change", (e) => {
                this.sliders.km.noUiSlider.set([e.target.value, null]);
                this.onSliderChange("km");
            });

            this.sliders.inputsKm.max?.addEventListener("change", (e) => {
                this.sliders.km.noUiSlider.set([null, e.target.value]);
                this.onSliderChange("km");
            });

            this.sliders.km.noUiSlider.on("change", () =>
                this.onSliderChange("km"),
            );
        }
    }

    // Gestione eventi checkbox
    bindCheckboxEvents() {
        // Vehicle Type
        this.addCheckboxEvent("type[]", () => this.onFilterChange());

        // Warranties
        this.addCheckboxEvent("warranties[]", (e) =>
            this.handleWarrantiesChange(e),
        );

        // Groups
        this.addCheckboxEvent("gruppi[]", () => this.onFilterChange());
    }

    addCheckboxEvent(name, handler) {
        document
            .querySelectorAll(`#${this.formId} input[name="${name}"]`)
            .forEach((checkbox) => {
                checkbox.addEventListener("change", handler);
            });
    }

    handleWarrantiesChange(e) {
        const hasWarrantyChecked = Array.from(this.checkboxes.warranties).some(
            (w) => w.checked,
        );

        this.checkboxes.groups.forEach((singleGroup) => {
            if (hasWarrantyChecked) {
                // Modalità warranty attiva
                singleGroup.checked = singleGroup.value !== "1";
                singleGroup.disabled = singleGroup.value === "1";
            } else {
                // Modalità normale - tutti i gruppi disponibili
                singleGroup.checked = false;
                singleGroup.disabled = false;
            }
        });

        this.onFilterChange();
    }

    bindSelectEvents() {
        this.selects.forEach((select) => {
            const element = document.getElementById(
                `${this.formId}select-${select}`,
            );
            if (element) {
                element.addEventListener("change", async (e) => {
                    // Se l'utente sceglie il placeholder (valore vuoto) -> reset totale
                    if (e.target.value === "") {
                        this.resetFilters();
                        return;
                    }

                    // L'utente ha scelto un'opzione: i valori iniziali del matrix
                    // non sono più rilevanti (niente bold, niente fallback)
                    this.useInitialValues = false;

                    // Rimuove subito il grassetto (prima della response)
                    e.target.classList.remove("initial-option");
                    e.target.style.fontWeight = "";

                    const selectedOption =
                        e.target.options[e.target.selectedIndex];
                    const isOtherOption =
                        selectedOption.getAttribute("data-type") === "other";

                    if (isOtherOption) {
                        this.resetAllOtherSelects(select);
                    }
                    const payload = {
                        ...this.getFormData(),
                        min_price: parseInt(
                            this.inputs.hidden.prices.min.value,
                        ),
                        max_price: parseInt(
                            this.inputs.hidden.prices.max.value,
                        ),
                        min_km: parseInt(this.inputs.hidden.km.min.value),
                        max_km: parseInt(this.inputs.hidden.km.max.value),
                    };

                    // Se si vuole che alle select
                    // si aggiornino sliders
                    // e input prices settare a true

                    this.update_prices = false;

                    // Chiamata 1: payload completo → aggiorna conteggio,
                    // slider e tutte le altre select.
                    await this.updateFilters(payload);

                    // Chiamata 2: stesso payload ma SENZA il filtro sulla
                    // dimensione appena cambiata → permette di ripopolare la
                    // select corrente con tutte le opzioni compatibili con
                    // gli altri filtri, così l'utente può cambiare scelta.
                    await this.refreshSelectOptions(select, payload);
                });
            }
        });
    }

    // Ripopola SOLO la select indicata con i valori disponibili
    // ignorando il filtro su quella stessa dimensione.
    async refreshSelectOptions(dimensionKey, basePayload) {
        const payloadWithoutSelf = { ...basePayload, [dimensionKey]: [] };

        // Tracking per evitare race condition tra richieste consecutive
        // sulla stessa select.
        this._selectRequestTokens = this._selectRequestTokens || {};
        const token = (this._selectRequestTokens[dimensionKey] || 0) + 1;
        this._selectRequestTokens[dimensionKey] = token;

        try {
            const response = await axios.post(this.apiUrl, payloadWithoutSelf);

            // Se nel frattempo è partita un'altra richiesta sulla stessa
            // select, ignora questa response (è stale).
            if (this._selectRequestTokens[dimensionKey] !== token) return;

            const dimensionToData = {
                bodytype: {
                    id: "select-bodytype",
                    filtered: response.data.bodytypes,
                    all: response.data.all?.bodytypes,
                    initial: this.initial?.body_type,
                },
                brand: {
                    id: "select-brand",
                    filtered: response.data.brands,
                    all: response.data.all?.brands,
                    initial: this.initial?.brand,
                },
                serie: {
                    id: "select-serie",
                    filtered: response.data.series,
                    all: response.data.all?.series,
                    initial: this.initial?.serie,
                },
                model: {
                    id: "select-model",
                    filtered: response.data.models,
                    all: response.data.all?.models,
                    initial: this.initial?.model,
                },
                fuel: {
                    id: "select-fuel",
                    filtered: response.data.fueltypes,
                    all: response.data.all?.fueltypes,
                    initial: this.initial?.fuel_type,
                },
                gear: {
                    id: "select-gear",
                    filtered: response.data.geartypes,
                    all: response.data.all?.geartypes,
                    initial: this.initial?.gear_type,
                },
            };

            const cfg = dimensionToData[dimensionKey];
            if (!cfg) return;

            const normalizeInitial = (value) =>
                Array.isArray(value) ? (value[0] ?? "") : (value ?? "");

            this.updateSelectWithFilteredFirst(
                `${this.formId}${cfg.id}`,
                cfg.filtered,
                cfg.all,
                normalizeInitial(cfg.initial),
            );
        } catch (error) {
            console.error("Error refreshing select options:", error);
        }
    }

    // Svuota tutte le select (usato quando l'utente cambia prezzo/km)
    resetSelects() {
        this.selects.forEach((selectType) => {
            const select = document.getElementById(
                `${this.formId}select-${selectType}`,
            );
            if (select) {
                select.value = "";
            }
        });
    }

    resetAllOtherSelects(currentSelectType) {
        this.selects.forEach((selectType) => {
            if (selectType !== currentSelectType) {
                const select = document.getElementById(
                    `${this.formId}select-${selectType}`,
                );
                if (select) {
                    select.value = "";
                }
            }
        });
    }

    // Gestione reset
    bindResetEvent() {
        this.resetButtons.forEach((button) => {
            button?.addEventListener("click", (e) => {
                e.preventDefault();
                this.resetFilters();
            });
        });
    }

    // Gestione cambio filtri
    async onFilterChange() {
        this.useInitialValues = false;
        this.resetSelects();
        await this.updateFilters(this.getFormData());
    }

    // Gestione Evento Slider Change
    async onSliderChange(sliderType) {
        this.useInitialPricesKm = false;
        this.useInitialValues = false;

        const slider = document.getElementById(
            `${this.formId}slider-${sliderType}`,
        );
        if (!slider?.noUiSlider) return;

        this.resetSelects();

        const values = slider.noUiSlider.get();
        const min_value = parseInt(values[0]);
        const max_value = parseInt(values[1]);

        const payload = {
            ...this.getFormData(),
            [sliderType === "budget" ? "min_price" : "min_km"]: min_value,
            [sliderType === "budget" ? "max_price" : "max_km"]: max_value,
        };

        if (sliderType === "budget") {
            if (this.inputs.hidden.prices.min)
                this.inputs.hidden.prices.min.value = min_value;
            if (this.inputs.hidden.prices.max)
                this.inputs.hidden.prices.max.value = max_value;
        } else if (sliderType === "km") {
            if (this.inputs.hidden.km.min)
                this.inputs.hidden.km.min.value = min_value;
            if (this.inputs.hidden.km.max)
                this.inputs.hidden.km.max.value = max_value;
        }

        await this.updateFilters(payload);
    }

    // Popola il payload
    getFormData() {
        const getCheckedValues = (name) => {
            return Array.from(
                document.querySelectorAll(
                    `#${this.formId} input[name="${name}"]:checked`,
                ),
            ).map((cb) => cb.value);
        };

        const getSelectValue = (id) => {
            const select = document.getElementById(`${this.formId}${id}`);
            return select ? select.value : "";
        };

        return {
            type: getCheckedValues("type[]"),
            warranty: getCheckedValues("warranties[]"),
            group: getCheckedValues("gruppi[]"),
            bodytype: [getSelectValue("select-bodytype")].filter(Boolean),
            brand: [getSelectValue("select-brand")].filter(Boolean),
            serie: [getSelectValue("select-serie")].filter(Boolean),
            model: [getSelectValue("select-model")].filter(Boolean),
            fuel: [getSelectValue("select-fuel")].filter(Boolean),
            gear: [getSelectValue("select-gear")].filter(Boolean),
            min_price: parseInt(this.inputs.hidden.prices.min.value),
            max_price: parseInt(this.inputs.hidden.prices.max.value),
            min_km: parseInt(this.inputs.hidden.km.min.value),
            max_km: parseInt(this.inputs.hidden.km.max.value),
        };
    }

    // Update Filters con chiamata alla apiUrl endpoint
    async updateFilters(payload) {
        try {
            this.showLoader(true);

            // console.group("📋 Payload");
            // console.table(payload);
            // console.groupEnd();

            const response = await axios.post(this.apiUrl, payload);

            // console.group("🍭 Conteggio");
            // console.table(response.data.conteggio);
            // console.groupEnd();

            this.updateUI(response.data);
        } catch (error) {
            console.error("Error updating filters:", error);
        } finally {
            this.showLoader(false);
        }
    }

    // Loader
    showLoader(show) {
        if (this.loaders.show) {
            if (this.loaders.loader && this.loaders.wrapper) {
                this.loaders.loader.style.opacity = show ? "1" : "0";
                this.loaders.wrapper.style.opacity = show ? "0.2" : "1";
            }
        }
    }

    // Bind Update UI
    updateUI(data) {
        this.updateSliders(data);
        this.updateDropdowns(data);
        this.updateCount(data.conteggio);
        // this.updateAlpineComponent(data.ids);
        // this.updateSingleAnnuncioComponent(data.ids);
    }

    // Update delle dropdowns
    updateDropdowns(data) {
        const mappings = {
            "select-bodytype": {
                filtered: data.bodytypes,
                all: data.all?.bodytypes,
                initial: this.initial?.body_type,
            },
            "select-brand": {
                filtered: data.brands,
                all: data.all?.brands,
                initial: this.initial?.brand,
            },
            "select-serie": {
                filtered: data.series,
                all: data.all?.series,
                initial: this.initial?.serie,
            },
            "select-model": {
                filtered: data.models,
                all: data.all?.models,
                initial: this.initial?.model,
            },
            "select-fuel": {
                filtered: data.fueltypes,
                all: data.all?.fueltypes,
                initial: this.initial?.fuel_type,
            },
            "select-gear": {
                filtered: data.geartypes,
                all: data.all?.geartypes,
                initial: this.initial?.gear_type,
            },
        };

        const normalizeInitial = (value) => {
            if (Array.isArray(value)) return value[0] ?? "";
            return value ?? "";
        };

        Object.entries(mappings).forEach(([id, items]) => {
            this.updateSelectWithFilteredFirst(
                `${this.formId}${id}`,
                items.filtered,
                items.all,
                normalizeInitial(items.initial),
            );
        });
    }

    // Select con risultati filtrati prima + altri dopo
    updateSelectWithFilteredFirst(
        selectId,
        filteredItems,
        allItems,
        initialValue,
    ) {
        const select = document.getElementById(selectId);
        if (!select) return;

        const currentValue =
            select.value || (this.useInitialValues ? initialValue : "") || "";
        const placeholder =
            select.querySelector('option[value=""]')?.textContent ||
            "Seleziona";

        select.innerHTML = `<option class="select-placeholder" value="">${placeholder}</option>`;

        // Crea mappe per accesso rapido
        const filteredMap = new Map(
            filteredItems
                .filter((item) => item.slug)
                .map((item) => [item.slug, item]),
        );
        const allMap = new Map(
            (allItems || [])
                .filter((item) => item.slug)
                .map((item) => [item.slug, item]),
        );

        // Aggiungi PRIMA gli item filtrati (con conteggio)
        let hasFilteredItems = false;
        filteredItems.forEach((item) => {
            if (item.slug) {
                const option = document.createElement("option");
                option.value = item.slug;
                option.textContent = `${item.name} (${item.total || 0})`;
                option.selected = item.slug === currentValue;
                option.className = "filtered-option";
                if (
                    this.useInitialValues &&
                    initialValue &&
                    item.slug === initialValue
                ) {
                    option.classList.add("initial-option");
                    option.style.fontWeight = "bold";
                }
                option.setAttribute("data-type", "filtered");
                select.appendChild(option);
                hasFilteredItems = true;
            }
        });

        // Aggiungi POI tutti gli altri item (senza conteggio)
        let hasOtherItems = false;
        allMap.forEach((item) => {
            if (item.slug && !filteredMap.has(item.slug)) {
                // if (!hasOtherItems && hasFilteredItems) {
                //     const separator = document.createElement("option");
                //     separator.disabled = true;
                //     separator.textContent = "-----";
                //     separator.className = "option-separator";
                //     separator.setAttribute("data-type", "separator");
                //     select.appendChild(separator);
                //     hasOtherItems = true;
                // }

                const option = document.createElement("option");
                option.value = item.slug;
                option.textContent = `${item.name} (${item.total || 0})`;
                option.selected = item.slug === currentValue;
                option.className = "other-option";
                if (
                    this.useInitialValues &&
                    initialValue &&
                    item.slug === initialValue
                ) {
                    option.classList.add("initial-option");
                    option.style.fontWeight = "bold";
                }
                option.setAttribute("data-type", "other");
                select.appendChild(option);
                hasOtherItems = true;
            }
        });

        // Se non ci sono opzioni valide, disabilita la select
        select.disabled = !(
            filteredItems.length > 0 || (allItems || []).length > 0
        );

        // Se la selezione corrente non è più disponibile, resetta
        if (
            currentValue &&
            !Array.from(select.options).some(
                (opt) => opt.value === currentValue,
            )
        ) {
            select.value = "";
        }

        // Rendi la select stessa in grassetto se il valore mostrato (chiuso)
        // è quello iniziale del matrix — altrimenti l'option bold non si vede
        if (
            this.useInitialValues &&
            initialValue &&
            select.value === initialValue
        ) {
            select.classList.add("initial-option");
            select.style.fontWeight = "bold";
        } else {
            select.classList.remove("initial-option");
            select.style.fontWeight = "";
        }
    }

    // Update degli slider solo se attivati manualmente, non dalle select
    updateSliders(data) {
        if (!this.update_prices) {
            this.update_prices = true;
            return;
        }

        const priceRange = this.useInitialPricesKm
            ? {
                  min_price: this.initial.min_price ?? this.initial.prices.min,
                  max_price:
                      this.initial.max_price ?? this.initial.prices.maxStock,
              }
            : data.price_range;
        const kmRange = this.useInitialPricesKm
            ? {
                  min_km: this.initial.min_km ?? this.initial.km.min,
                  max_km: this.initial.max_km ?? this.initial.km.maxStock,
              }
            : data.km_range;

        const updateSlider = (
            sliderId,
            range,
            inputFirstId,
            inputLastId,
            fallback,
        ) => {
            const slider = document.getElementById(`${this.formId}${sliderId}`);
            const inputFirst = document.getElementById(
                `${this.formId}${inputFirstId}`,
            );
            const inputLast = document.getElementById(
                `${this.formId}${inputLastId}`,
            );

            if (slider?.noUiSlider && range) {
                // `??` e non `||`: uno 0 è un valore valido. Con `||` un
                // min_price a 0 cadeva su range.min_km (undefined) e l'input
                // del prezzo minimo restava vuoto.
                const minValue =
                    range.min_price ?? range.min_km ?? fallback.min;
                const maxValue =
                    range.max_price ?? range.max_km ?? fallback.max;

                slider.noUiSlider.set([minValue, maxValue]);
                if (this.update_input_prices) {
                    if (inputFirst) inputFirst.value = minValue;
                    if (inputLast) inputLast.value = maxValue;
                }
            }
        };

        updateSlider(
            "slider-budget",
            priceRange,
            "input-price-first",
            "input-price-last",
            { min: this.initial.prices.min, max: this.initial.prices.maxStock },
        );
        updateSlider("slider-km", kmRange, "input-km-first", "input-km-last", {
            min: this.initial.km.min,
            max: this.initial.km.maxStock,
        });
    }

    // Update dei conteggi
    updateCount(count) {
        if (this.conteggio.element) {
            const spinner = this.conteggio.element.querySelector(".spinner");
            spinner?.remove();
            this.conteggio.element.textContent = count;
        }
    }

    // Reset filtri
    resetFilters() {
        this.useInitialValues = false;
        this.useInitialPricesKm = true;

        // Azzera i valori iniziali venuti dalla querystring così che
        // updateSliders usi i min/max puri dello stock come fallback
        this.initial.min_price = null;
        this.initial.max_price = null;
        this.initial.min_km = null;
        this.initial.max_km = null;

        // Reset checkboxes
        document
            .querySelectorAll(`#${this.formId} input[type="checkbox"]`)
            .forEach(
                (checkbox) => (checkbox.checked = checkbox.disabled = false),
            );

        // Reset select
        document
            .querySelectorAll(`#${this.formId} select`)
            .forEach((select) => (select.selectedIndex = 0));

        // Reset sliders
        const resetSlider = (sliderId, min, max) => {
            const slider = document.getElementById(`${this.formId}${sliderId}`);
            slider?.noUiSlider?.set([min, max]);
        };

        resetSlider(
            "slider-budget",
            this.initial.prices.min,
            this.initial.prices.maxStock,
        );
        resetSlider("slider-km", this.initial.km.min, this.initial.km.maxStock);

        this.inputs.hidden.prices.min.value = this.initial.prices.min;
        this.inputs.hidden.prices.max.value = this.initial.prices.maxStock;
        this.inputs.hidden.km.min.value = this.initial.km.min;
        this.inputs.hidden.km.max.value = this.initial.km.maxStock;

        // Reset input visibili prezzo/km
        if (this.sliders.inputsPrices.min)
            this.sliders.inputsPrices.min.value = this.initial.prices.min;
        if (this.sliders.inputsPrices.max)
            this.sliders.inputsPrices.max.value = this.initial.prices.maxStock;
        if (this.sliders.inputsKm.min)
            this.sliders.inputsKm.min.value = this.initial.km.min;
        if (this.sliders.inputsKm.max)
            this.sliders.inputsKm.max.value = this.initial.km.maxStock;

        // Ricarica i filtri
        this.onFilterChange();
    }

    // FirstCheck
    async firstCheck() {
        // Prima controlla e imposta i valori iniziali
        const checkCheckboxes = (checkboxes, initialValues) => {
            if (!initialValues || !Array.isArray(initialValues)) return;

            checkboxes.forEach((checkbox) => {
                const checkboxValue = String(checkbox.value).trim();
                const shouldBeChecked = initialValues.some(
                    (initialValue) =>
                        String(initialValue).trim() === checkboxValue,
                );
                checkbox.checked = shouldBeChecked;
            });
        };

        // Imposta le checkbox
        checkCheckboxes(this.checkboxes.types, this.initial?.type);
        checkCheckboxes(this.checkboxes.warranties, this.initial?.warranties);
        checkCheckboxes(this.checkboxes.groups, this.initial?.group);

        // Poi prepara il payload per l'API
        const firstMappingDataFromInitial = {
            type: this.initial?.type,
            warranty: this.initial?.warranties,
            group: this.initial?.group,
            bodytype: [this.initial?.body_type],
            brand: [this.initial?.brand],
            serie: [this.initial?.serie],
            model: [this.initial?.model],
            fuel: [this.initial?.fuel_type],
            gear: [this.initial?.gear_type],
            min_price: this.initial?.min_price,
            max_price: this.initial?.max_price,
            min_km: this.initial?.min_km,
            max_km: this.initial?.max_km,
        };

        // console.group("🚗 First Mapping");
        // console.table(firstMappingDataFromInitial);
        // console.groupEnd();

        // Aggiorna i filtri con i valori iniziali
        await this.updateFilters(firstMappingDataFromInitial);

        // Nascondi i loader
        if (this.loaders.loader && this.loaders.wrapper) {
            this.loaders.loader.style.opacity = "0";
            this.loaders.wrapper.style.opacity = "1";
        }

        // if (this.update_input_prices) {
        //     this.update_input_prices = false;
        // }
    }

    formatMoney(value) {
        return new Intl.NumberFormat("it-IT", {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    }

    formatKm(value) {
        return new Intl.NumberFormat("it-IT").format(value) + " Km";
    }

    // =============================================
    // =============================================
    // PER RENDERING ANNUNCI
    // =============================================
    // =============================================
    // async updateSingleAnnuncioComponent(vehicleIds) {
    //     const listContainer = document.getElementById("annunci-container");

    //     if (listContainer) {
    //         try {
    //             const response = await axios.post("/render-single-annuncio", {
    //                 vehicles: vehicleIds,
    //             });

    //             listContainer.innerHTML = response.data.html;
    //         } catch (error) {
    //             console.error("Error updating component:", error);
    //             listContainer.innerHTML = "<div>Errore nel caricamento</div>";
    //         }
    //     }
    // }

    // =============================================
    // =============================================
    // PER RENDERING CONTEGGIO
    // =============================================
    // =============================================
    // updateAlpineComponent(vehicleIds) {
    //     const event = new CustomEvent("alpine:vehicles-updated", {
    //         detail: {
    //             ids: vehicleIds,
    //             conteggio: vehicleIds.length,
    //             timestamp: new Date().toISOString(),
    //         },
    //     });
    //     window.dispatchEvent(event);
    // }
}
